import { defineComponent as _defineComponent } from 'vue'
import ProfileView from '@/features/user-profile/components/ProfileView.vue';
import InfiniteScroll from '@/components/list/InfiniteScroll.vue';
import TextRecommendationCard from '@/features/why-to-watch/components/TextRecommendationCard.vue';

import { useUserProfile } from '@/features/user-profile/composables/useUserProfile';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserTextRecommendations',
  setup(__props) {

const { profile, textRecommendations, isLoading, loadNextRecommendations, isAtEndOfRecommendations } = useUserProfile();

return { __sfc: true,profile, textRecommendations, isLoading, loadNextRecommendations, isAtEndOfRecommendations, ProfileView, InfiniteScroll, TextRecommendationCard }
}

})